import React from 'react';
import QuantitySelector from '../commons/quantity-selector/QuantitySelector';
import ProductDefaultImage from '../../assets/images/product-default-image.jpg'

const ProductList = ({products, onChangeProductQuantity, onDeleteProduct, viewMode}) => {

  return (
    <div className="cart-card cart-products-card">
      <div className="cart-card-header">
        <h3>Shopping Cart</h3>
        <span className="item-count">{products ? products.length : 0} items</span>
      </div>
      <div className="cart-items-list">
        {products && products.map((p, idx) => {
          const product = {...p};
          const discounts = product.QuantityDiscount && product.QuantityDiscount
            .sort((a, b) => b.quantity - a.quantity);

          if (discounts && discounts.length > 0) {
            product.bundledDiscount = product.QuantityDiscountOddItems ?
            discounts.filter(d =>
              d.quantity <= product.quantity) ?
                discounts.filter(d => d.quantity <= product.quantity)[0]
                : undefined
              : discounts.find(d => d.quantity === product.quantity);

            if (product.bundledDiscount) {
              product.SalePrice = product.bundledDiscount.priceB;
              product.bundle = true;
            } else {
              product.bundle = false;
            }
          }

          const renderPrice = () => {
            if (product.PriceB && (product.OnSale || product.bundle)) {
              return (
                <span className="sale-price">
                  <s>{`$${ parseFloat(product.PriceB).toFixed(2)}`}</s>
                  {` $${ parseFloat(product.SalePrice).toFixed(2)}`}
                </span>
              );
            }

            return product.PriceB
              ? `$${ parseFloat(product.PriceB).toFixed(2)}`
              : '';
          };

          const renderTotal = () => {
            if (product.PriceB && product.quantity && (product.OnSale || product.bundle)) {
              return (
                <span className="sale-price">
                  <s>{`$${ (parseFloat(product.PriceB) * parseFloat(product.quantity)).toFixed(2)}`}</s>
                  {` $${ (parseFloat(product.SalePrice) * parseFloat(product.quantity)).toFixed(2)}`}
                </span>
              );
            }

            return product.PriceB && product.quantity
              ? `$${ (parseFloat(product.PriceB) * parseFloat(product.quantity)).toFixed(2)}`
              : '';
          };

          return (
            <div className="cart-item" key={`product_${idx}`}>
              <div className="cart-item-media">
                <div className="thumb"><img src={product.image
              ? product.image
              : ProductDefaultImage} alt="product thumbnail" onError={(e) => {
                    return e.target.src = ProductDefaultImage
                  }}/></div>
                <div className="cart-item-info">
                  <a href={`/products/${product._id}`} className="cart-item-name">{product && product.Description
                        ? product['Sub Description 2'] ? product['Sub Description 3'] ? product.Description + ' ' + product['Sub Description 2'] + ' ' + product['Sub Description 3']:product.Description + ' ' + product['Sub Description 2']: product.Description:''}</a>
                  <span className="cart-item-meta">{product['Sub Description 2'] || product.Size || product.Volume || product['Sub Description 3']}</span>
                </div>
              </div>
              <div className="cart-item-price">{renderPrice()}</div>
              <div className="cart-item-quantity">
                {viewMode && viewMode === 'edit'
                  ? (<QuantitySelector quantity={product.quantity
                    ? product.quantity
                    : 0} onChangeQuantity={(qty) => onChangeProductQuantity(product, qty)} minimumQuantity={1}/>)
                  : product.quantity}
              </div>
              <div className="cart-item-total">{renderTotal()}</div>
              {viewMode && viewMode === 'edit'
                ? (
                  <button className="remove-item" onClick={(e) => onDeleteProduct ? onDeleteProduct(product._id) : null} aria-label="Remove item">
                    <i className="fa fa-trash-o delete-product-button"/>
                  </button>
                )
                : null}

            </div>
          )
        })}
      </div>
    </div>
  );
};

export default ProductList;



// WEBPACK FOOTER //
// ./src/components/cart/ProductList.js